import React from 'react';

export default function AuthFormContainer({ title, children, footer }) {
  return (
    <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {title}
          </h2>
        </div>
        <div className="bg-white p-8 shadow-xl rounded-2xl space-y-6">
          {children}
        </div>
        <div className="text-center text-sm text-gray-600">
          {footer}
        </div>
      </div>
    </div>
  );
}
